import { useDataValue } from 'Simple/Data.js'
import startOfDay from 'date-fns/startOfDay'
import endOfDay from 'date-fns/startOfDay'
import format from 'date-fns/format'

function getFilterConditions(filters) {
  let conditions = []

  if (filters.stage_ids?.length) {
    conditions.push({ stage_id: { _in: filters.stage_ids } })
  }
  if (filters.location_ids?.length) {
    conditions.push({ location_id: { _in: filters.location_ids } })
  }
  if (filters.priorities?.length) {
    conditions.push({ priority: { _in: filters.priorities } })
  }
  if (filters.assignee_ids?.length) {
    conditions.push({ assignees: { user_id: { _in: filters.assignee_ids } } })
  }
  if (filters.tag_ids?.length) {
    conditions.push({ task_tags: { tag_id: { _in: filters.tag_ids } } })
  }
  if (filters.is_past_due_date) {
    conditions.push({ due_date: { _lt: 'now' } })
  }
  // the due date doesn't have a timezone, we'll keep date as plain sql timetamps
  if (filters.due_date?.from && filters.due_date?.to) {
    conditions.push({
      due_date: {
        _gte: format(
          startOfDay(new Date(filters.due_date.from)),
          'yyyy-MM-dd HH:mm:ss'
        ),
        _lte: format(
          endOfDay(new Date(filters.due_date.to)),
          'yyyy-MM-dd HH:mm:ss'
        ),
      },
    })
  }

  if (filters.patient_ids?.length) {
    conditions.push({
      patients: {
        _id: { _in: filters.patient_ids },
      },
    })
  }

  return conditions
}

export default function useDataConfiguration(props) {
  let board_id = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'selected.board_id',
  })

  let filters = useDataValue({
    viewPath: props.viewPath,
    context: 'filters',
  })

  return {
    variables: {
      board_id,
      and: getFilterConditions(filters),
    },
    pause: !board_id || board_id === 'new',
  }
}
